import { R$ } from 'shared/helpers/currency';
import { Periodicity } from 'shared/types/periodicity';

export interface IService {
  id?: number;
  name?: string;
  base_price?: number;
  periodicity?: Periodicity;
  desc?: string;
  renewable?: boolean;
  selectable?: boolean;
  removable?: boolean;
  changeable?: boolean;
  is_license?: number;
  order_model?: number;
  jump?: string;
  slug?: string;
  software_id?: number;
  created_at?: string;
  updated_at?: string;
}

export class Service
  implements
    Omit<
      IService,
      | 'base_price'
      | 'created_at'
      | 'updated_at'
      | 'software_id'
      | 'order_model'
      | 'jump'
      | 'slug'
      | 'removable'
      | 'changeable'
      | 'selectable'
      | 'renewable'
      | 'desc'
    >
{
  id?: number;
  name?: string;
  value?: number;
  periodicity?: Periodicity;
  is_license?: number;

  constructor(data?: IService) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.value = Number(data.base_price);
      this.periodicity = data.periodicity;
      // this.desc = data.desc;
      // this.base_price = data.base_price;
      // this.renewable = data.renewable;
      // this.selectable = data.selectable;
      // this.removable = data.removable;
      // this.changeable = data.changeable;
      this.is_license = data.is_license;
      // this.order_model = data.order_model;
      // this.jump = data.jump;
      // this.slug = data.slug;
      // this.software_id = data.software_id;
    }
  }

  get selectedPeriodicity() {
    return this.periodicity === 'monthly' ? 'Mensal' : 'Anual';
  }

  get priceString() {
    return R$(this.value);
  }
}
